<script setup lang="ts">
    export interface Props {
        label?: string;
    }

    defineProps<Props>();
</script>

<template>
    <div class="app-card-content-group text-subtitle-2 text-secondary-text">
        <slot></slot>
        <div class="app-card-content-label text-caption text-secondary">
            {{ label }}
        </div>
    </div>
</template>

<style scoped>
    .app-card-content-group {
        min-width: 100px;
    }

    .app-card-content-label {
        //font-size: 14px;
    }
</style>
